module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v3/sp/common/mark_circle-35366e7810c767217061e3c9d054bdd4.svg";